<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">绑定/解绑FRM</h1>
        <h3 class="doc_main_h3">（1）提取FRM绑定码信息</h3>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			根据FRM提供的绑定码信息，绑定本地终端需要关联的项目人员组的信息。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public boolean SKFaceGetBindFRMInfo(String BindCode, GetBindFRMInfoCallbackInterface GetBindFRMInfoCallback)
// 获取FRM绑定信息回调接口
public interface GetBindFRMInfoCallbackInterface {
    void GetBindFRMInfoCallback(int Code, String BindFRMInfo);
}</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）BindCode：FRM绑定码</p>
        <p class="doc_main_p">（2）GetBindFRMInfoCallback：获取FRM绑定信息（比如项目名称、人员组名称...）回调接口</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">（1）boolean类型，true表示成功，可处理回调结果；false表示失败（绑定码格式有误），无需处理回调（回调不返回信息）</p>
        <p class="doc_main_p">（2）GetBindFRMInfoCallback(int Code, String BindFRMInfo)：
Code错误码，0：获取绑定码信息成功，其他：失败
BindFRMInfo为绑定FRM信息（比如项目名称、人员组名称...），Code非0时为错误信息，json字符串格式需解析使用。</p>
        <h3 class="doc_main_h3">错误码列表</h3>
        <authority-error-code></authority-error-code>
        <p class="doc_main_p"></p>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">boolean flag = skFace.SKFaceGetBindFRMInfo("2sdfasdhw", new GetBindFRMInfoCallbackInterface() {
    @Override
    public void GetBindFRMInfoCallback(int Code, String BindFRMInfo) {
        // TODO 在这里接收FRM绑定信息
    }
});</code></pre>
    <h3 class="doc_main_h3">（2）绑定FRM</h3>
    <h3 class="doc_main_h3">功能描述</h3>
	<p class="doc_main_p">
		终端与项目、人员组进行绑定，绑定后可实现云端人员数据同步。
	</p>
    <h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public boolean SKFaceBindFRM(String BindCode, BindFRMCallbackInterface BindFRMCallback)
//绑定FRM回调接口
public interface BindFRMCallbackInterface {
    void BindFRMCallback(int Code, String Msg);
}</code></pre>
    <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）BindCode：FRM绑定码</p>
        <p class="doc_main_p">（2）BindFRMCallback：绑定FRM的结果回调接口</p>
         <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">（1）boolean类型，true表示成功，可处理回调结果；false表示失败（绑定码格式有误），无需处理回调（回调不返回信息）</p>
        <p class="doc_main_p">（2）BindFRMCallback(int Code, String Msg)：Code错误码，0为成功，其他失败；Msg：错误消息</p>
        <h3 class="doc_main_h3">错误码列表</h3>
        <authority-error-code></authority-error-code>
        <p class="doc_main_p"></p>
        <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">boolean flag = skFace.SKFaceBindFRM("2sdhcosd", new BindFRMCallbackInterface() {
    @Override
    public void BindFRMCallback(int Code, String Msg) {
        //TODO 在这里接收绑定FRM结果信息
    }
});</code></pre>
        <h3 class="doc_main_h3">（3）解绑</h3>
    <h3 class="doc_main_h3">功能描述</h3>
	<p class="doc_main_p">
		取消终端当前项目、人员组的绑定关系。解绑后，本地同步的人员数据将会删除。
	</p>
    <h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceUnBindFRM(UnBindFRMCallbackInterface UnBindFRMCallback)

//解绑FRM回调接口
public interface UnBindFRMCallbackInterface {
    void UnBindFRMCallback(int Code, String Msg);
}</code></pre>
     <h3 class="doc_main_h3">参数</h3>
     <p class="doc_main_p">UnBindFRMCallback：解绑FRM的结果回调接口</p>
     <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">UnBindFRMCallback(int Code, String Msg)：Code错误码，0为成功，其他失败；Msg：错误消息。</p>
        <h3 class="doc_main_h3">错误码列表</h3>
        <authority-error-code></authority-error-code>
        <p class="doc_main_p"></p>
     <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceUnBindFRM(new UnBindFRMCallbackInterface() {
    @Override
    public void UnBindFRMCallback(int Code, String Msg) {
        //TODO 在这里接收解绑FRM的结果信息
    }
});</code></pre>
 <h3 class="doc_main_h3">（4）获取终端当前绑定信息</h3>
    <h3 class="doc_main_h3">功能描述</h3>
	<p class="doc_main_p">
		获取终端当前已绑定的项目、人员组信息。
	</p>
    <h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public String SKFaceGetDeviceBindInfo()</code></pre>
     <h3 class="doc_main_h3">参数</h3>
     <p class="doc_main_p">无</p>
     <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">String类型，json格式字符串，表示本机当前FRM绑定信息</p>
        <pre class="doc_main_pre"><code class="doc_main_code">Json示例：
{
    "project_key":"5ebe41fb0afd0a59631108370378",
    "project_name":"FRMtestzwcai",
    "server_url":"http://skfrm.sk-ai.com"
}
含义：
{
    "project_key":绑定项目/分组的key,
    "project_name":绑定项目/分组的名称,
    "server_url":云端服务器地址
}</code></pre>
     <h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">String deviceBindInfo = skFace.SKFaceGetDeviceBindInfo();</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';   
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,        
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','FRM接口','绑定/解绑FRM'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/frm/Unbound.vue